// src/components/Codeworkflow/AuditorView/AuditorView.jsx
import React, { useEffect, useRef, useState, useCallback } from "react";
import "./AuditorView.css";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import urgentIcon from "../../../common/assets/images/Variation 2.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { debounce, orderBy } from "lodash";
import {
  Table,
  Badge,
  Pagination,
  Card,
  Placeholder,
  Spinner,
  Form,
} from "react-bootstrap";
import { Box, Menu, MenuItem, Tooltip } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  faSort,
  faSortAmountUp,
  faSortAmountDown,
  faUser,
  faUserInjured,
  faBed,
} from "@fortawesome/free-solid-svg-icons";
import {
  getAuditorViewData,
  getAuditorViewStatsData,
  updateFilters,
  updateAuditorPage,
  getAllQueuesData,
  // getAuditorViewFiltersData,
  // getAuditorSidePanelData,
  resetAuditorFilters,
  showAvailableAuditQueues,
  setQueueFilterSearch,
  setPriorityFilterSearch,
  setStatusFilterSearch,
  getSpecialityFilterOptions,
  getAuditorViewCardData,
} from "./redux/AuditorViewSlicer";
import { useDispatch, useSelector } from "react-redux";
import { fetchCdqHistoryResponse, fetchUserPreferences } from "../CoderView/redux/CoderScreenSlice";
import { Link, useNavigate } from "react-router-dom";
import {
  resetDocumentViewerError,
  resetDocumentViewerLoadedData,
  resetEpisodeIdentifierTopassDocumentViewer,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { selectedEpisodeList } from "../../pages/EpisodeList/redux/EpisodeListSlicer";
import { useMediaQuery } from "@mui/material";
import AuditorSideDrawer from "./mobile/AuditorSideDrawer";
import AuditorFilterModal from "./AuditorFilterModal";
import RefershIcon from "../../../common/assets/images/reload.png";
import { CloudCog } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  setEpisodeIdentiferFilterSearch,
  setHealthFundFilterContractSearch,
  setMRNFilterSearch,
  setProvisionalDrgFilterSearch,
  setSpecialityFilterSearch,
} from "../HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import CdqResponseHistoryModal from "../CdqResponseHistoryModal/CdqResponseHistoryModal";

const AuditorView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width: 1024px)");
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const isSanEnvironment = codebooksanEnv || codebooksanprodEnv;
  const loginUserID = JSON.parse(sessionStorage.getItem("userId")) || {};

  // states
  const [selectedDrgMap, setSelectedDrgMap] = useState({});
  const [drgAnchorEl, setDrgAnchorEl] = useState(null);
  const [activeDrgRow, setActiveDrgRow] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  // Use the manually selected DRG when available; otherwise use the default DRG.
  // If no default exists, return -1 so the table displays "-" until one is selected.
  const getSelectedDrgIndex = (hcpLineId, drgs = []) => {
    const manuallySelectedIndex = selectedDrgMap[hcpLineId];

    if (
      manuallySelectedIndex !== undefined &&
      manuallySelectedIndex >= 0 &&
      manuallySelectedIndex < drgs.length &&
      drgs[manuallySelectedIndex]
    ) {
      return manuallySelectedIndex;
    }

    return drgs.findIndex((drg) => drg?.is_default === true);
  };
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [activeQueue, setActiveQueue] = useState(null);
  const [globalSearch, setGlobalSearch] = useState(false);
  const [preferences, setPreferences] = useState({});
  const [episodesData, setEpisodesData] = useState([]);
  const [showUserPreferenceModal, setShowUserPreferenceModal] = useState(false);
  const [showAuditorFilter, setShowAuditorFilter] = useState(false);
  const [auditorQueues, setAuditorQueues] = useState([]);
  const [expandedQueues, setExpandedQueues] = useState(new Set());
  const [clickedEpisodeQueues, setClickedEpisodeQueues] = useState([]);
  const [isReasonAvailable, setIsReasonAvailable] = useState(false);
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const [queueSelected, setQueueSelected] = useState(loginUserID);
  const [selectedQueueIndex, setSelectedQueueIndex] = useState(null);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [showCdqModal, setShowCdqModal] = useState(false);
    const [selectedCdqRecord, setSelectedCdqRecord] = useState(null);
    const [cdqPageNumber, setCdqPageNumber] = useState(1);
 const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
 const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

   const CDQ_PAGE_SIZE = 4
  // selectors
  const filtersPayload = useSelector(
    (state) => state.auditorView.auditorViewEpisodesPayload,
  );
  const preferencesLoading = useSelector(
    (state) => state.coderscreenqueue.loadingPreferencesData,
  );
  const forAuditCount = useSelector(
  (state) => state.auditorView.getQueuesData.forAuditCount
  );

  const {
    queuesData,
    auditorData,
    queuesLoading,
    queueMeta,
    drgInsurers,
    drgInsurersMeta,
    loadingMoreQueues,
    loadingDRGInsurers,
  } = useSelector((state) => state.auditorView.getQueuesData);
  const { auditorViewStatsLoading, auditorViewStatsData } = useSelector(
    (state) => state.auditorView.auditorViewStats,
  );
  const {
    showAvailableAuditQueuesLoading,
    showAvailableAuditQueuesData,
    showAvailableAuditQueuesError,
  } = useSelector((state) => state.auditorView.showAvailableAuditQueues);
  const { specialityFilterOptions, queueFilterOptions } = useSelector(
    (state) => state.auditorView,
  );

  const { auditorViewData, auditorViewDataLoading, auditorViewDataError } =
    useSelector((state) => state.auditorView.auditorViewResponse);
  const { auditorViewCardLoading, auditorViewCardData, auditorViewCardError } =
    useSelector((state) => state.auditorView.auditorViewCards);
   const cdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.cdqHistoryData,
     );
     const loadingCdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.loadingCdqHistoryData,
     );
     const errorCdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.errorCdqHistoryData,
     );
  const updateSelectedDrgIndex = (hcpLineId, index) => {
    setSelectedDrgMap((prev) => ({
      ...prev,
      [hcpLineId]: index,
    }));
  };
  const openDrgMenu = (event, hcpLineId) => {
    setDrgAnchorEl(event.currentTarget);
    setActiveDrgRow(hcpLineId);
  };

  const closeDrgMenu = () => {
    setDrgAnchorEl(null);
    setActiveDrgRow(null);
  };

  const queueTypes = auditorViewData?.episodes?.flatMap((episode) =>
    episode.queue?.map((q) => q.queue_type),
  );

  const handleViewCdqResponses = (episodeItem) => {
      setSelectedCdqRecord(episodeItem);
      setShowCdqModal(true);
      dispatch(
        fetchCdqHistoryResponse({
          hcp_line_id: episodeItem?.hcp_line_id,
          role:"auditor",
          page_number: 1
        }),
      );
    };
    const handleCdqPageChange = (nextPage) => {
        if (nextPage < 1) return;
        setCdqPageNumber(nextPage);
        dispatch(
          fetchCdqHistoryResponse({
            hcp_line_id: selectedCdqRecord?.hcp_line_id,
             role:"auditor",
            page_number: nextPage,
            // page_size: CDQ_PAGE_SIZE,
          }),
        );
      };

    const handleCloseCdqModal = () => {
    setShowCdqModal(false);
    setSelectedCdqRecord(null);
  };

  const handleQueueSelect = (queue, section = "") => {
    if (section === "auditorQueues") {
      setIsOptionSelected(true);
    } else {
      setIsOptionSelected(true);
    }

    setSelectedSection(section);
    setSelectedQueue(queue);
    setSelectedQueueIndex(queue);
    setQueueSelected(queue?.assigned_user_id || loginUserID);
  };

  useEffect(() => {
    if (!clickedEpisodeQueues?.length) return;
    if (selectedQueueIndex !== null) return;

    // Filter queues into categories for default selection
    const assignedAuditorQueues = clickedEpisodeQueues.filter(
      (q) =>
        q?.assigned_user_id &&
        q?.assigned_username &&
        q?.queue_id !== null &&
        q?.queue_id !== undefined &&
        q?.queue_name?.trim() &&
        (q?.assignment_reason === null ||
          q?.assignment_reason === undefined ||
          q?.assignment_reason === "") &&
        filtersPayload.queue?.length === 0,
    );

    const cdqReviewQueues = clickedEpisodeQueues.filter(
      (q) =>
        q?.assigned_user_id &&
        q?.assigned_username &&
        (q?.queue_id === null || q?.queue_id === undefined) &&
        (!q?.queue_name || !q.queue_name.trim()) &&
        (q?.assignment_reason === null ||
          q?.assignment_reason === undefined ||
          q?.assignment_reason === ""),
    );

    const forReviewQueues = clickedEpisodeQueues.filter(
      (q) =>
        q?.assigned_user_id &&
        q?.assigned_username &&
        q?.line_assignment_id &&
        q?.assignment_reason &&
        q.assignment_reason.trim() !== "",
    );

    const availableQueues = clickedEpisodeQueues.filter(
      (q) => !("assigned_user_id" in q),
    );

    // Select first available queue based on priority
    let defaultQueue = null;
    let defaultSection = "";

    if (assignedAuditorQueues?.length > 0) {
      defaultQueue = assignedAuditorQueues[0];
      defaultSection = "assignedAuditor";
    } else if (cdqReviewQueues?.length > 0) {
      defaultQueue = cdqReviewQueues[0];
      defaultSection = "CDQReview";
    } else if (forReviewQueues?.length > 0) {
      defaultQueue = forReviewQueues[0];
      defaultSection = "forReview";
    } else if (availableQueues?.length > 0) {
      defaultQueue = availableQueues[0];
      defaultSection = "auditorQueues";
    }

    if (defaultQueue) {
      setSelectedQueue(defaultQueue);
      setSelectedQueueIndex(defaultQueue);
      setSelectedSection(defaultSection);
      setQueueSelected(defaultQueue?.assigned_user_id || loginUserID);
    }
  }, [clickedEpisodeQueues, loginUserID]);

  const hasAssignedAuditorForLoginUser = clickedEpisodeQueues.some(
    (q) =>
      q.assigned_user_id === loginUserID &&
      (q.assignment_reason === null ||
        q.assignment_reason === undefined ||
        q.assignment_reason === ""),
  );

  const hasReviewForLoginUser = clickedEpisodeQueues.some(
    (q) => q.assigned_user_id === loginUserID && q.assignment_reason?.trim(),
  );

  const isLock = auditorViewData?.episodes?.[0]?.is_locked ?? "";
  const sendallQueuesData = auditorViewData?.episodes?.flatMap((episode) =>
    episode?.queue?.map((q) => q),
  );
  const isAuditor = queueTypes?.includes("AUDIT");
  useEffect(() => {
    dispatch(getAllQueuesData({ pageNumber: 1 }));
    dispatch(getAuditorViewStatsData({}));
    dispatch(getAuditorViewData(filtersPayload));
    dispatch(getAuditorViewCardData(filtersPayload));
    dispatch(getAuditorViewStatsData(filtersPayload));
    dispatch(
      getSpecialityFilterOptions({
        search: specialityFilterOptions.search,
        page_number: 1,
        page_size: 10,
      }),
    );
  }, []);

  const auditorContainerRef = useRef(null);

  const selectedQueues = (filtersPayload?.queue || [])
    .map((id) =>
      (queueFilterOptions?.data || []).find((queue) => queue.queue_id === id),
    )
    .filter(Boolean);

  const queueNames = selectedQueues.map((queue) => queue.queue_name);

  const isCodeEnhanceMode = activeQueue?.queue_name
    ?.toLowerCase()
    ?.includes("code enhance");

  const isSearchActive = filtersPayload.episode_identifier_search?.length > 0;

  // const totalPages =
  //   typeof auditorViewData?.meta?.total_count === "number" &&
  //   typeof 10 === "number" &&
  //   10 > 0
  //     ? Math.max(1, Math.ceil(auditorViewData?.meta?.total_count / 10))
  //     : 1;
  const totalCount = auditorViewData?.episode_meta_data?.meta?.total_count || 0;

  const pageSize = filtersPayload?.page_size || 10;

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const dataToDisplay = episodesData?.length > 0 && episodesData;

  const loadQueues = (pageNumber) => {
    dispatch(getAllQueuesData({ pageNumber, isDRGPage: false }));
  };

  // 🏦 LOAD DRG INSURERS
  const loadDRGInsurers = (pageNumber) => {
    dispatch(getAllQueuesData({ pageNumber, isDRGPage: true }));
  };

  const isFetchingRef = useRef(false);

  // Replace the scroll handler useEffect with this SIMPLE version:
  useEffect(() => {
    let scrollTimeout;

    const handleScroll = (e) => {
      const container = e.target;
      const queueId = container.getAttribute("data-drg-container");

      if (!queueId) return;

      // Get scroll position
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isAtBottom = scrollHeight - scrollTop - clientHeight < 50;

      if (!isAtBottom) return;

      // Get metadata
      const drgMeta = drgInsurersMeta[queueId];
      const isLoading = loadingDRGInsurers[queueId];

      // Prevent multiple calls
      if (!drgMeta?.has_more || isLoading || isFetchingRef.current) {
        return;
      }

      // Calculate next page
      const nextPage = (drgMeta.page || 1) + 1;
      const currentQueuePage = queueMeta.page || 1;

      // Set fetching flag
      isFetchingRef.current = true;

      // Dispatch API call
      dispatch(
        getAllQueuesData({
          pageNumber: nextPage,
          isDRGPage: true,
          currentQueuePage: currentQueuePage,
        }),
      ).finally(() => {
        // Reset flag after API call completes
        setTimeout(() => {
          isFetchingRef.current = false;
        }, 1000); // Prevent rapid calls for 1 second
      });
    };

    // Function to setup listeners
    const setupListeners = () => {
      // Clear existing timeout
      if (scrollTimeout) clearTimeout(scrollTimeout);

      // Wait for DOM
      scrollTimeout = setTimeout(() => {
        const containers = document.querySelectorAll("[data-drg-container]");
        containers.forEach((container) => {
          container.removeEventListener("scroll", handleScroll);
          container.addEventListener("scroll", handleScroll);
        });
      }, 500);
    };

    // Setup initially
    setupListeners();

    // Re-setup when expanded queues change
    const intervalId = setInterval(setupListeners, 2000);

    // Cleanup
    return () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      clearInterval(intervalId);

      const containers = document.querySelectorAll("[data-drg-container]");
      containers.forEach((container) => {
        container.removeEventListener("scroll", handleScroll);
      });
    };
  }, [
    expandedQueues,
    drgInsurersMeta,
    loadingDRGInsurers,
    queueMeta,
    dispatch,
  ]);

  useEffect(() => {
    return () => {
      // ✅ This runs when user LEAVES auditor workspace
      dispatch(resetAuditorFilters());
    };
  }, [dispatch]);

   useEffect(() => {
  const updatePageSize = () => {
    const screenHeight = window.innerHeight;
    const reservedHeight =  360;
    const rowHeight = 36;
   const availableHeight =
    screenHeight - reservedHeight;
   const dynamicRows = Math.floor(
      availableHeight / rowHeight
    );
  const finalPageSize =
      dynamicRows > 10 ? dynamicRows : 10;
   setEpisodesPerPage(finalPageSize)
   const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: finalPageSize,
    };

    dispatch(updateFilters(payload));
    dispatch(getAuditorViewData(payload));
    dispatch(getAuditorViewCardData(payload));
    dispatch(getAuditorViewStatsData(payload));
  };

  updatePageSize();

  window.addEventListener(
    "resize",
    updatePageSize
  );

  return () => {
    window.removeEventListener(
      "resize",
      updatePageSize
    );
  };
}, []);

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: Number(event.target.value),
    };

    dispatch(updateFilters(payload));
    dispatch(getAuditorViewData(payload));
    dispatch(getAuditorViewCardData(payload));
    dispatch(getAuditorViewStatsData(payload));
  };

  const auditorDashboardOptions =
    Array.isArray(auditorViewCardData?.cards) &&
    auditorViewCardData.cards.length > 0
      ? Object.entries(auditorViewCardData.cards[0]).map(([key, value]) => ({
          name:
            key === "urgent"
              ? "Urgent"
              : key === "episodes_to_audit"
                ? "Episodes to Audit"
                : key === "for_review"
                  ? "For Review"
                  : "",
          count: value,
          icon:
            key === "urgent"
              ? urgentIcon
              : key === "episodes_to_audit"
                ? uncodedIcon
                : inprogressIcon,
          backgroundColor:
            key === "urgent"
              ? "#FEF2F2"
              : key === "episodes_to_audit"
                ? "#EFF6FF"
                : "#ECFDF5",
        }))
      : [];

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      dispatch(getAuditorViewData(payload));
      dispatch(getAuditorViewCardData(payload));
      dispatch(getAuditorViewStatsData(payload));
      dispatch(updateFilters(payload));
    }
  };

  const handleUserClick = () => {
    setActiveQueue(null);
    const payload = {
      ...filtersPayload,
      page_number: 1,
      episode_identifier_search: "",
      is_user_specific: true,
      queue: [],
      health_fund_contract: [],
    };
    dispatch(updateFilters(payload));
    setCoderSearchTerm("");
    dispatch(getAuditorViewData(payload));
    dispatch(getAuditorViewCardData(payload));
    dispatch(getAuditorViewStatsData(payload));
  };

  const handleSelectQueueEpisodes = (queueItem) => {
    setActiveQueue(queueItem);
    let queueId = queueItem.queue_id;
    let healthFundContract = null;

    // Check if this is a child item (insurer)
    if (queueItem.is_insurer && queueItem.parent_queue_id) {
      // Find the parent queue to get its name
      const parentQueue = auditorQueues.find(
        (q) => q.queue_id === queueItem.parent_queue_id,
      );
      if (parentQueue) {
        // Use parent queue name for the queue filter
        queueId = parentQueue.queue_id;
        // Use child queue name for health fund contract
        healthFundContract = queueItem.queue_name;
      }
    }
    const isCodeEnhance = queueItem.queue_name === "Code Enhance";
    const payload = {
      // ...filtersPayload,
      page_number: 1,
      page_size: 10,
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      health_fund_contract: [],
      los: [],
      speciality: [],
      medical_record_number: [],
      status: [],
      priority: [],
      episode_identifier_search: [],
      // no_mrn: false,
      // no_priority: false,
      // no_los: false,
      los: [],
      los_op: "",
      drg_code: [],
      // unassigned: true,
      queue: [queueId],

      health_fund_contract: healthFundContract ? [healthFundContract] : [],
      sort_by: [],
      sort_order: [],
      is_user_specific: false,
    };
    dispatch(getAuditorViewCardData(payload));
    dispatch(updateFilters(payload));
    dispatch(getAuditorViewData(payload)).then((res) => {
      setEpisodesData(res.payload.episodes);
    });
    const keysToRemove = ["queue_page_number", "page_number"];
    const statsPayload = { ...payload };
    keysToRemove.forEach((key) => {
      delete statsPayload[key];
    });
    dispatch(getAuditorViewStatsData(statsPayload));
    setCoderSearchTerm("");
  };

  // Update the toggleQueueExpand function to ensure initial load:
  const toggleQueueExpand = useCallback(
    (queueId) => {
      setExpandedQueues((prev) => {
        const newSet = new Set(prev);
        const queue = auditorQueues.find((q) => q.queue_id === queueId);
        const isDRGQueue = queue?.isDRGQueue;

        if (newSet.has(queueId)) {
          // Collapsing
          newSet.delete(queueId);
        } else {
          // Expanding
          newSet.add(queueId);

          // If it's a DRG queue and we haven't loaded insurers yet
          if (
            isDRGQueue &&
            queueId &&
            (!drgInsurers[queueId] ||
              Object.keys(drgInsurers[queueId]).length === 0)
          ) {
            console.log(`📥 Initial load for DRG queue ${queueId}`);
            // The initial insurers are already loaded with queues, so no need to call API
          }
        }

        return newSet;
      });
    },
    [auditorQueues, drgInsurers],
  );

  const processQueues = useCallback(
    (queues) => {
      if (!queues || !Array.isArray(queues)) return [];

      return queues.map((queue) => {
        const queueId = queue.queue_id;
        const isDRGQueue = queueId === 70; // Direct check

        // Get insurers data
        let insurersToShow = {};

        if (isDRGQueue && drgInsurers[queueId]) {
          // Use accumulated DRG insurers
          insurersToShow = drgInsurers[queueId];
        } else if (queue.insurers) {
          // Use queue's own insurers
          insurersToShow = queue.insurers;
        }

        // Create children
        const children = Object.entries(insurersToShow).map(
          ([name, count]) => ({
            queue_id: `${queueId}-${name}`,
            queue_name: name,
            number_of_episodes: count,
            is_insurer: true,
            parent_queue_id: queueId,
          }),
        );

        // Sort
        children.sort((a, b) => a.queue_name.localeCompare(b.queue_name));

        return {
          ...queue,
          children,
          has_insurers: children.length > 0,
          queue_id: queueId,
          isDRGQueue,
          insurers: insurersToShow,
        };
      });
    },
    [drgInsurers],
  );

  useEffect(() => {
    if (queuesData && !queuesLoading) {
      // Check the structure of your API response

      let queuesArray = [];

      // Adjust this based on your actual API response structure
      if (Array.isArray(queuesData)) {
        queuesArray = queuesData;
      } else if (queuesData?.queues && Array.isArray(queuesData.queues)) {
        queuesArray = queuesData.queues;
      } else if (queuesData?.data && Array.isArray(queuesData.data)) {
        queuesArray = queuesData.data;
      }

      if (queuesArray.length > 0) {
        const processed = processQueues(queuesArray);
        setAuditorQueues(processed);
      } else {
        // If no queues, set empty array
        setAuditorQueues([]);
      }
    }
  }, [queuesData, queuesLoading]);

  // Initial load
  useEffect(() => {
    // Load dummy queues
    // loadDummyQueues();
    // dispatch(getAllQueuesData(1));
    dispatch(getAllQueuesData({ pageNumber: 1 }));

    // Load other real data
    dispatch(getAuditorViewStatsData(filtersPayload));
    dispatch(getAuditorViewData(filtersPayload));
    dispatch(getAuditorViewCardData(filtersPayload));
  }, []);

  useEffect(() => {
    setEpisodesData(auditorViewData.episodes || []);
  }, [auditorViewData]);

  const checkAuditorPermissionAndNavigate = (selectedRecord) => {
    // ✅ Get CODER queues from THIS SPECIFIC episode and store in state
    setSelectedRecord(selectedRecord);
    setIsOptionSelected(false);
    const episodeCoderQueues =
      selectedRecord?.queue?.filter(
        (q) =>
          q.queue_type === "CODER" ||
          q.queue_type === "AUDIT" ||
          q.queue_type === "CODINGSUPPORT",
      ) || [];

    // ✅ If episode has exactly one CODER queue, auto-select it
    if (episodeCoderQueues.length === 1) {
      setSelectedQueue(episodeCoderQueues[0]);
    }
    const updatedRecord = {
      ...selectedRecord,
      episode_identifier: selectedRecord.episode_identifier,
    };
    sessionStorage.setItem("filters", JSON.stringify(filtersPayload));
    sessionStorage.setItem("last_hcp_line_id", updatedRecord?.hcp_line_id);
    const payload = {
      hcp_line_id: updatedRecord?.hcp_line_id,
      screen_type: "auditor",
    };
    dispatch(showAvailableAuditQueues(payload)).then((res) => {
      if (res?.payload) {
        const allQueues = [
          ...(res.payload.queues || []),
          ...(res.payload.queues_user || []),
        ];
        const hasNoReason =
          allQueues?.length > 1 &&
          allQueues.some(
            (item) =>
              item.assignment_reason && item.assignment_reason.trim() !== null,
          );
        setSelectedQueue(null);
        setSelectedQueueIndex(null);
        setClickedEpisodeQueues(allQueues);
        setIsReasonAvailable(hasNoReason);
        if (allQueues.length > 0) {
          let selectResponseQueue;
          if (filtersPayload?.queue?.length > 0) {
            selectResponseQueue = allQueues.find(
              (item) => item.queue_id == filtersPayload.queue,
            );
          } else {
            const loginUserQueue = allQueues.find(
              (item) => item.assigned_user_id === loginUserID,
            );
            selectResponseQueue = loginUserQueue || allQueues[0];
          }
          setSelectedQueue(selectResponseQueue);
        }
      }
    });
    dispatch(resetEpisodeIdentifierTopassDocumentViewer());
    sessionStorage.setItem("currentPage", "auditorPage");
    dispatch(resetDocumentViewerLoadedData());
    dispatch(selectedEpisodeList(updatedRecord));
    dispatch(resetDocumentViewerError());
    dispatch(fetchUserPreferences()).then((res) => {
      setPreferences(res.payload);

      if (
        preferences?.["Code Accelerate"] !== false ||
        preferences?.["Code Assist"] !== false
      ) {
        setShowUserPreferenceModal(true);
      } else if (episodeCoderQueues.length === 0) {
        if (preferences["Code Accelerate"]) {
          navigate("/Auditor-Coding-Screen", {
            state: {
              from: "auditor",
              queue_id: null,
              queue_type: null,
            },
          });
        } else if (preferences["Code Assist"]) {
          navigate("/Auditor-CodeAssist-Screen", {
            state: {
              from: "auditor",
              queue_id: null,
              queue_type: null,
            },
          });
        } else {
          toast.error("You are not subscribed to any of the coding modules");
        }
      } else if (episodeCoderQueues.length > 1) {
        setShowUserPreferenceModal(true);
      }
      // ✅ If episode has single queue and user has single module, navigate directly
      else {
        const queueToUse = episodeCoderQueues[0];

        if (preferences["Code Accelerate"]) {
          navigate("/Auditor-Coding-Screen", {
            state: {
              from: "auditor",
              queue_id: queueToUse?.queue_id,
              queue_type: queueToUse?.queue_type,
            },
          });
        } else if (preferences["Code Assist"]) {
          navigate("/Auditor-CodeAssist-Screen", {
            state: {
              from: "auditor",
              queue_id: queueToUse?.queue_id,
              queue_type: queueToUse?.queue_type,
            },
          });
        } else {
          toast.error("You are not subscribed to any of the coding modules");
        }
      }
    });
  };

  const getPatientTypeIcon = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return faBed;
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return faUserInjured;
    }
    return faUser; // default icon
  };

  const getPatientTypeColor = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return "#4CAF50";
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return "#2196F3";
    }
    return "#757575";
  };

  const navigateToDesiredPage = (type) => {
    // ✅ Allow navigation even without queues
    let queueToUse = null;
    const selectedQueueData =
      clickedEpisodeQueues.find((q) => q.line_assignment_id) ||
      clickedEpisodeQueues[0];

    // ✅ Only require queue selection if episode has multiple queues
    if (isAuditor && clickedEpisodeQueues.length > 1 && !selectedQueue) {
      toast.error("Please select a queue before proceeding");
      return;
    }

    // ✅ Get the queue to use
    if (clickedEpisodeQueues.length === 1) {
      queueToUse = clickedEpisodeQueues[0];
    } else if (clickedEpisodeQueues.length > 1 && selectedQueue) {
      queueToUse = selectedQueue;
    }

    const isLockedKey = selectedRecord?.is_locked || isLock;

    if (type === "accelerate") {
      navigate("/Auditor-Coding-Screen", {
        state: {
          from: "auditor",
          isLockedKey,
          queue_id: queueToUse?.queue_id || null,
          queue_type: queueToUse?.queue_type || null,
          line_assignment_id: queueToUse?.line_assignment_id || null,
        },
      });
      sessionStorage.setItem(
        "lineAssignmentId",
        queueToUse?.line_assignment_id || null,
      );
    } else if (type === "assist") {
      navigate("/Auditor-CodeAssist-Screen", {
        state: {
          from: "auditor",
          isLockedKey,
          queue_id: queueToUse?.queue_id || null,
          queue_type: queueToUse?.queue_type || null,
          line_assignment_id: queueToUse?.line_assignment_id || null,
        },
      });
      sessionStorage.setItem(
        "lineAssignmentId",
        queueToUse?.line_assignment_id || null,
      );
    }

    sessionStorage.setItem("filters", JSON.stringify(filtersPayload));
    dispatch(updateAuditorPage(false));
    setShowUserPreferenceModal(false);
  };

  const getStatsDetails = () => {
    const statsDetails = auditorViewStatsData?.stats?.find(
      (item) => "total_number_of_episodes" in item,
    );
    return statsDetails;
  };

  //Padlock
  const functionLocked = () => {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24">
        <rect
          x="5"
          y="11"
          width="14"
          height="10"
          rx="2.5"
          stroke="#000"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M8 11V7.5a4.5 4.5 0 0 1 9 0V11"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  };

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(getAuditorViewData(payload));
      dispatch(getAuditorViewCardData(payload));
      dispatch(getAuditorViewStatsData(payload));
    }, 1000),
    [],
  );
  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setShowOptions(false);

    dispatch(
      updateFilters({
        ...filtersPayload,
        episode_identifier_search: [],
        is_user_specific: true,
        medical_record_number: "",
        is_global_search: false,
        page_number: 1,
      }),
    );
  };

  const handleSearchEpisode = (e) => {
    const rawValue = e.target.value;
    setCoderSearchTerm(rawValue);
    const cleanedValue = rawValue.trim().replace(/\s+/g, " ");

    const isSearching = rawValue.length > 0;
    setGlobalSearch(isSearching);
    if (isSearching) {
      setSelectedQueue(null);
    }
    const payload = {
      ...filtersPayload,
      page_number: 1,
      is_global_search: true,
      episode_identifier_search: searchType === "episode" ? rawValue : [],
      medical_record_number:
        searchType === "mrn" ? (rawValue ? rawValue : []) : [],
    };
    setShowOptions(false);

    dispatch(updateFilters(payload));
    const APIpayload = {
      ...filtersPayload,
      page_number: 1,
      episode_identifier_search:
        searchType === "episode" && cleanedValue ? [cleanedValue] : [],
      medical_record_number:
        searchType === "mrn" && cleanedValue ? [cleanedValue] : [],
    };
    debounceSearchHandler(APIpayload);
  };

  useEffect(() => {
    if (globalSearch) {
      setSelectedQueue(null);
    }
  }, [globalSearch]);

  const getHighlightedText = (text) => {
    const fullText = text || "";
    const searchValue = filtersPayload?.episode_identifier_search;

    // Normalize to array
    const searchArray = Array.isArray(searchValue)
      ? searchValue
      : searchValue
        ? [searchValue]
        : [];

    if (!searchArray.length) return fullText;

    // Create regex from all search terms
    const escapedTerms = searchArray
      .filter(Boolean)
      .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

    if (!escapedTerms.length) return fullText;

    const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");

    const parts = fullText.split(regex);

    return (
      <>
        {parts.map((part, index) =>
          escapedTerms.some(
            (term) => part.toLowerCase() === term.toLowerCase(),
          ) ? (
            <span key={index} style={{ backgroundColor: "yellow" }}>
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </>
    );
  };

  const renderQueueItem = (queueItem, isChild = false) => {
    const queueId = queueItem.queue_id;
    // Add this line to define isDRGQueue:
    const isDRGQueue =
      queueItem.queue_name?.includes("DRG") ||
      queueItem.queue_name?.includes("Optimisation");
    const hasChildren = queueItem.children && queueItem.children.length > 0;
    const isExpanded = expandedQueues.has(queueId);

    // Truncate queue name for display
    const MAX_NAME_LENGTH = isChild ? 18 : 22;
    const displayName =
      queueItem.queue_name.length > MAX_NAME_LENGTH
        ? `${queueItem.queue_name.substring(0, MAX_NAME_LENGTH)}...`
        : queueItem.queue_name;

    return (
      <React.Fragment key={queueItem.queue_id}>
        <div
          className={`left-auditor-workflow-queues-card-top ${
            isChild ? "queue-child-item" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (!isChild && hasChildren) {
              toggleQueueExpand(queueId);
            } else {
              handleSelectQueueEpisodes(queueItem);
            }
          }}
          style={{
            cursor: "pointer",
            padding: "8px 12px",
            margin: "4px 0",
            display: "flex",
            alignItems: "center",
            borderRadius: "6px",
            transition: "background-color 0.2s",
            backgroundColor: isChild ? "#f8fafc" : "transparent",
            borderLeft: isChild ? "2px solid #e2e8f0" : "none",
            marginLeft: isChild ? "24px" : "0",
            paddingLeft: isChild ? "24px" : "12px",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = isChild
              ? "#f1f5f9"
              : "#f3f4f6")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = isChild
              ? "#f8fafc"
              : "transparent")
          }
        >
          <div
            style={{
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
              minWidth: "18px",
            }}
          >
            <img
              src={generalsurgeryIcon}
              alt=""
              style={{
                width: isChild ? "12px" : "14px",
                height: isChild ? "12px" : "14px",
                opacity: isChild ? 0.7 : 1,
              }}
            />
          </div>

          <Tooltip title={queueItem?.queue_name} arrow placement="right">
            <div
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                style={{
                  fontSize: isChild ? "12px" : "13px",
                  fontWeight: isChild ? "400" : "500",
                  color: isChild ? "#4b5563" : "#374151",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {displayName}
              </span>

              {!isChild && hasChildren && (
                <span
                  style={{
                    fontSize: "10px",
                    color: "#6b7280",
                    flexShrink: 0,
                  }}
                >
                  {isExpanded ? "▼" : "▶"}
                </span>
              )}
            </div>
          </Tooltip>

          <div
            style={{
              fontSize: isChild ? "11px" : "12px",
              fontWeight: "500",
              color: "#6b7280",
              marginLeft: "10px",
              flexShrink: 0,
              minWidth: "40px",
              textAlign: "right",
            }}
          >
            ({queueItem?.number_of_episodes})
          </div>
        </div>

        {/* Render children if expanded */}
        {!isChild && hasChildren && isExpanded && (
          <div
            // Add data attribute for DRG containers
            data-drg-container={isDRGQueue ? queueId : undefined}
            style={{
              marginLeft: "24px",
              maxHeight: isDRGQueue ? "150px" : "none",
              overflowY: isDRGQueue ? "auto" : "visible",
            }}
          >
            {queueItem.children.map((child) => renderQueueItem(child, true))}
          </div>
        )}
      </React.Fragment>
    );
  };
  const handleSort = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    let order = "asc";

    if (currentSortBy === columnKey && currentSortOrder === "asc") {
      order = "desc";
    }

    const updatedFilters = {
      ...filtersPayload,
      sort_by: [columnKey],
      sort_order: [order],
      page_number: 1,
    };

    dispatch(updateFilters(updatedFilters));
    dispatch(getAuditorViewData(updatedFilters));
    dispatch(getAuditorViewCardData(updatedFilters));
    dispatch(getAuditorViewStatsData(filtersPayload));
  };
  const renderSortIcon = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return faSort; // neutral
    }

    return currentSortOrder === "asc" ? faSortAmountUp : faSortAmountDown;
  };
  const getSortTooltip = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return "Click to sort";
    }

    return currentSortOrder === "asc"
      ? "Sorted Ascending"
      : "Sorted Descending";
  };

  const handleModalClose = () => {
    setShowAuditorFilter(false);
    dispatch(resetAuditorFilters());
    dispatch(setEpisodeIdentiferFilterSearch(""));
    dispatch(setMRNFilterSearch(""));
    dispatch(setSpecialityFilterSearch(""));
    dispatch(setQueueFilterSearch(""));
    dispatch(setPriorityFilterSearch(""));
    dispatch(setStatusFilterSearch(""));
    dispatch(setHealthFundFilterContractSearch(""));
    dispatch(setProvisionalDrgFilterSearch(""));
    setCoderSearchTerm("");
    const resetState = {
      page_number: 1,
      page_size: 10,
      separation_date_from: null,
      separation_date_to: null,
      admission_date_to: null,
      admission_date_from: null,
      health_fund_contract: [],
      los: [], // Only this array, no los/los_op/los_to
      queue: [],
      speciality: [],
      medical_record_number: [],
      ur_number: [],
      status: [],
      priority: [],
      episode_identifier_search: [],
      is_user_specific: true,
      // no_mrn: false,
      // no_priority: false,
      // no_los: false,
      los_op: null,
      drg_code: [],
      sort_by: [],
      sort_order: [],
      is_global_search: false,
    };
    dispatch(getAuditorViewData(resetState));
    dispatch(getAuditorViewCardData(resetState));
    dispatch(getAuditorViewStatsData(resetState));
  };

  const auditorViewStatsOptions = [
    {
      name: "Audited",
      name_color: "#349AD7",
      value: auditorViewStatsData?.stats?.[0]?.total_number_of_episodes ?? 0,
      bg_color: "#bfdcff4d",
      borderColor: "#BFDBFE",
    },
    {
      name: "NWAU",
      name_color: "#16A34A",
      value: `${Number(auditorViewStatsData?.stats?.[0]?.total_weight ?? 0).toFixed(2)}`,
      bg_color: "#bbf7d04d",
      borderColor: "#BBF7D0",
    },
    {
      name: "Revenue",
      name_color: "#9333EC",
      value: `$${auditorViewStatsData?.stats?.[0]?.total_revenue ?? 0}`,
      bg_color: "#e9d5ff4d",
      borderColor: "#E9D5FF",
    },
     {
      name: "Total LOS",
      name_color: "#F28F0C",
      value: `${auditorViewStatsData?.stats?.[0]?.total_los ?? 0 } ${auditorViewStatsData?.stats?.[0]?.total_los > 1 ? "Days" : "Day"}`,
      bg_color: "#fed7aa4d",
      borderColor: "#FED7AA",
    },
    {
      name: "Average LOS",
      name_color: "#0D9488",
      value: `${Number(auditorViewStatsData?.stats?.[0]?.average_los ?? 0).toFixed(1)} ${auditorViewStatsData?.stats?.[0]?.average_los > 1 ? "Days" : "Day"}`,
      bg_color: "#99f6e44d",
      borderColor: "#99F6E4",
    },
  ];

    const formatYYYYMMDD = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(d.getDate()).padStart(2, "0")}`
      : null;

  // ============================================================
  // CENTRALIZED HIGHLIGHT RESOLVER
  // ============================================================
  const getHighlightState = ({
    assignedAuditorQueues,
    cdqReviewQueues,
    forReviewQueues,
    availableQueues,
  }) => {
    const hasFilterQueue = filtersPayload?.queue?.length > 0;

    let activeSection = null;

    if (hasFilterQueue && availableQueues.length > 0) {
      activeSection = "auditorQueues";
    } else if (assignedAuditorQueues.length > 0) {
      activeSection = "assignedAuditor";
    } else if (cdqReviewQueues.length > 0) {
      activeSection = "CDQReview";
    } else if (forReviewQueues.length > 0) {
      activeSection = "forReview";
    } else if (availableQueues.length > 0) {
      activeSection = "auditorQueues";
    }

    return { activeSection, hasFilterQueue };
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="workflow-auditor-container">
        {!isMobile && (
          <div
            lg="3"
            sm="12"
            xs="12"
            md="12"
            className="left-auditor-workflow-card"
          >
            <div className="left-auditor-workflow-card-top-header">
              <img
                src={backIcon}
                className="left-auditor-workflow-card-icon"
                onClick={() => navigate("/Code-Workflow")}
                style={{ cursor: "pointer" }}
              />
              <p className="left-auditor-workflow-card-text">
                Back to Workflow
              </p>
            </div>
            <div className="left-auditor-workflow-card-header">
              <p className="left-auditor-workflow-card-heading-text">
                My Tasks
              </p>
              <div className="left-auditor-workflow-top-card">
                <p className="left-auditor-workflow-card-subheading-text">
                  For Audit
                </p>
                {/* <p className="left-auditor-workflow-card-count">{`(${auditorViewFiltersData?.for_audited ?? 0})`}</p> */}
                <p className="left-auditor-workflow-card-count">
                  {/* {specialityFilterOptions.loading
                    ? 0
                    : specialityFilterOptions.forAuditedCount
                      ? specialityFilterOptions.forAuditedCount
                      : 0} */}
                  {forAuditCount}
                </p>
              </div>
            </div>
            <div className="left-auditor-workflow-queues-card">
              <p className="left-auditor-workflow-queues-card-header">Queues</p>
              <div
                className="auditor-workflow-queues-container"
                ref={auditorContainerRef}
                style={{
                  maxHeight: "280px",
                  overflowY: "auto",
                  paddingRight: "8px",
                }}
              >
                {auditorQueues.length === 0 ? (
                  <div
                    className="left-auditor-workflow-queues-error"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#6b7280",
                    }}
                  >
                    {/* Loading queues... */}
                    <Spinner />
                  </div>
                ) : (
                  auditorQueues.map((queueItem) => renderQueueItem(queueItem))
                )}
              </div>
              {/* ================= AUDITORS SECTION ================= */}

              <p className="left-auditor-workflow-queues-card-header">
                Auditors
              </p>

              <div
                className="auditor-workflow-queues-container"
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  paddingRight: "8px",
                }}
              >
                {queuesLoading ? (
                  <div
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#6b7280",
                    }}
                  >
                    <Spinner />
                  </div>
                ) : auditorData?.length > 0 ? (
                  auditorData?.map((auditor) => (
                    <div
                      key={auditor.user_id}
                      className="left-auditor-workflow-queues-card-top"
                      style={{
                        cursor: "pointer",
                        padding: "8px 12px",
                        margin: "4px 0",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "6px",
                      }}
                    >
                      {/* Icon */}
                      <div style={{ marginRight: "10px" }}>
                        <img
                          src={userIcon}
                          alt=""
                          style={{ width: "15px", height: "15px" }}
                        />
                      </div>

                      {/* Name */}
                      <div style={{ flex: 1 }} onClick={handleUserClick}>
                        <span style={{ fontSize: "13px", fontWeight: "500" }}>
                          {auditor.auditor_name}
                        </span>
                      </div>

                      {/* Count */}
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#6b7280",
                          marginLeft: "10px",
                        }}
                      >
                        ({auditor.number_of_episodes})
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "10px", color: "#999" }}>
                    No auditors found
                  </div>
                )}
              </div>

              <div className="stats-section">
                <p className="stats-text">My Stats</p>
                {auditorViewStatsLoading ? (
                  <Placeholder animation="glow">
                    <Placeholder xs={12} className="statsPlaceholder" />
                  </Placeholder>
                ) : (
                  <div>
                    <div>
                      <div className="workflow-coderview-mystats-date-card">
                        <label className="workflow-him-filter-label">
                          Filter by Date Range
                        </label>
                         <DatePicker
                      selected={
                        filtersPayload.separation_date_from
                          ? new Date(filtersPayload.separation_date_from)
                          : null
                      }
                      startDate={
                        filtersPayload.separation_date_from
                          ? new Date(filtersPayload.separation_date_from)
                          : null
                      }
                      endDate={
                        filtersPayload.separation_date_to
                          ? new Date(filtersPayload.separation_date_to)
                          : null
                      }
                      selectsRange
                      className="workflow-coderview-mystats-date-picker"
                      placeholderText="Select Date Range"
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      onChange={(dates) => {
                        const [from, to] = dates;

                        // update selected dates in redux
                        dispatch(
                          updateFilters({
                            ...filtersPayload,
                            separation_date_from: from
                              ? formatYYYYMMDD(from)
                              : null,
                            separation_date_to: to ? formatYYYYMMDD(to) : null,
                          }),
                        );

                        // Call API only after both dates selected
                        if (from && to) {
                          const payload = {
                            ...filtersPayload,
                            separation_date_from: formatYYYYMMDD(from),
                            separation_date_to: formatYYYYMMDD(to),
                          };

                          dispatch(getAuditorViewStatsData(payload));
                        }
                      }}
                    />
                      </div>
                    </div>
                    {/* {auditorViewStatsOptions?.map((item) => (
                      <div
                        style={{
                          // background: item?.bg_color,
                          border: `2px solid #CBD5E14D`,
                          padding: "5px",
                          borderRadius: "4px",
                          margin: "7px 0px",
                        }}
                      >
                        <p style={{ color: "#ABB3B7", marginBottom: "7px" }}>
                          {item?.name}
                        </p>
                        <p style={{ fontSize: "16px", color: "#2B3437" }}>
                          {item?.value}
                        </p>
                      </div>
                    ))} */}

                    <div className="stats-top-wrapper">
                      {auditorViewStatsOptions?.map((item) => (
                        <div
                          key={item.name}
                          style={{
                            background: item?.bg_color,
                            border: `2px solid ${item?.borderColor}`,
                            padding: "5px",
                            borderRadius: "10px",
                            margin: "4px 0px",
                            minHeight: "65px",
                          }}
                        >
                          <p style={{ color: item?.name_color, fontSize: "13px" }}>
                            {item?.name}
                          </p>
                          <p style={{ fontSize: "16px" }}>{item?.value}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="right-auditor-workflow-card">
          {isMobile && (
            <div className="mobile-qc-header">
              <img
                src={backIcon}
                alt="back"
                className="mobile-qc-back-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <span className="mobile-qc-back-text">Back to Workflow</span>
            </div>
          )}
          <div className="auditor-dashboard">
            {auditorViewDataLoading ? (
              <Placeholder
                as={Card.Text}
                animation="glow"
                style={{ width: "100%" }}
              >
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={3} className="PlaceholderItem" />{" "}
              </Placeholder>
            ) : (
              auditorDashboardOptions?.length > 0 &&
              auditorDashboardOptions?.map((dashboardItem) => (
                <div
                  key={dashboardItem?.name}
                  className="auditor-dashboard-cards"
                  style={{ backgroundColor: dashboardItem?.backgroundColor }}
                >
                  <div className="auditor-dashboard-cards-top">
                    <p className="auditor-dashboard-name">
                      {dashboardItem?.name}
                    </p>
                    <p className="auditor-dashboard-icon">
                      <img
                        src={dashboardItem?.icon}
                        alt={dashboardItem?.name}
                      />
                    </p>
                  </div>
                  <p className="auditor-dashboard-count">
                    {dashboardItem?.count}
                  </p>
                </div>
              ))
            )}
          </div>
          {isMobile && (
            <div className="mobile-view-filter">
              <AuditorSideDrawer
                auditorQueues={auditorQueues}
                auditorViewData={auditorViewData}
                getStatsDetails={getStatsDetails}
                handleSelectQueueEpisodes={handleSelectQueueEpisodes}
                renderQueueItem={renderQueueItem}
                expandedQueues={expandedQueues}
                toggleQueueExpand={toggleQueueExpand}
              />
            </div>
          )}

          <div className="workflow-auditor-table-container">
            <div className="auditor-header-container">
              {/* LEFT: Total Episodes */}
              <div className="workflow-auditor-selected-rows-count">
                <Badge className="workflow-auditor-selected-rows-count-badge">
                  Total Episodes: {totalCount}
                </Badge>
              </div>

              {/* GAP */}
              <div className="auditor-header-spacer" />

              {/* SEARCH */}
              <div className="workflow-auditor-table-header-search-container">
                <img
                  src={search_icon}
                  alt="search"
                  style={{ height: "18px", paddingLeft: "5px" }}
                />
                <input
                  className="workflow-auditor-table-header-search-input"
                  value={coderSearchTerm}
                  // value={
                  //   searchType === "episode"
                  //     ? filtersPayload.episode_identifier_search
                  //     : filtersPayload.medical_record_number
                  // }
                  placeholder={
                    searchType === "episode"
                      ? "Search by Episode ID"
                      : "Search by MRN"
                  }
                  onFocus={() => setShowOptions(true)}
                  onBlur={() => setTimeout(() => setShowOptions(false), 150)}
                  onChange={handleSearchEpisode}
                />
                {showOptions && (
                  <div className="search-options-dropdown">
                    <div
                      className={`search-option ${searchType === "episode" ? "active" : ""}`}
                      onMouseDown={() => handleSearchTypeChange("episode")}
                    >
                      Search by Episode ID
                    </div>

                    <div
                      className={`search-option ${searchType === "mrn" ? "active" : ""}`}
                      onMouseDown={() => handleSearchTypeChange("mrn")}
                    >
                      Search by MRN
                    </div>
                  </div>
                )}
              </div>

              {/* FILTER ICON */}
              <span
                style={{ cursor: "pointer" }}
                onClick={() => setShowAuditorFilter(true)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#1f1f1f"
                >
                  <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z" />
                </svg>
              </span>

              {/* REFRESH */}
              <div
                className="him-refresh-btn"
                onClick={() => {
                  // const refreshPayload = { ...filtersPayload, page_number: 1 };
                  const refreshPayload = {
                    page_number: 1,
                    page_size: 10,
                    // unassigned: false,
                    separation_date_from: null,
                    separation_date_to: null,
                    admission_date_from: null,
                    admission_date_to: null,
                    health_fund_contract: [],
                    los: [],
                    queues: [],
                    speciality: [],
                    medical_record_number: [],
                    status: [],
                    priority: [],
                    episode_identifier_search: [],
                    is_user_specific: true,
                    no_mrn: false,
                    no_priority: false,
                    no_los: false,
                    los_op: null,
                    drg_code: [],
                    sort_by: [],
                    sort_order: [],
                    is_global_search: false,
                  };
                  dispatch(getAuditorViewData(refreshPayload));
                  dispatch(getAuditorViewCardData(refreshPayload));
                  dispatch(getAuditorViewStatsData(refreshPayload));
                  dispatch(updateFilters(refreshPayload));
                  setCoderSearchTerm("");
                }}
              >
                <img src={RefershIcon} alt="Refresh" />
              </div>
            </div>

            <div className="workflow-auditor-table-body">
              <Table className="workflow-table-Hims" style={{ width: "100%" }}>
                <thead className="workflow-auditor-table-thead">
                  <tr className="workflow-auditor-table-tr">
                    {isCodeEnhanceMode ? (
                      // --- CODE ENHANCE Headings ---
                      <>
                        {codebookusaEnv && (
                          <th className="workflow-coder-table-th">
                            <div>
                              <span>Episode Type</span>
                            </div>
                          </th>
                        )}
                        <th className="workflow-auditor-table-th">
                          <span></span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("episode_identifier")}
                        >
                          <span>Episode Identifier</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("episode_identifier")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("episode_identifier")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("medical_record_number")}
                        >
                          <span>MRN/UR</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("medical_record_number")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("medical_record_number")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("admission_date")}
                        >
                          <span>Admission Date</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("admission_date")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("admission_date")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("separation_date")}
                        >
                          <span>Discharge Date</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("separation_date")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("separation_date")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("length_of_stay")}
                        >
                          <span>LOS</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("length_of_stay")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("length_of_stay")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("speciality")}
                        >
                          <span>Speciality</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("speciality")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("speciality")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("insurer_identifier")}
                        >
                          <span>Health Fund Contract</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("insurer_identifier")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("insurer_identifier")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("drg_codes")}
                        >
                          <span>Pre Audit DRG</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("drg_codes")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("drg_codes")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("weight")}
                        >
                          <span>Pre Audit Revenue</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("weight")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("weight")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("audit_findings")}
                        >
                          <span>Audit Rule Findings</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("audit_findings")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("audit_findings")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("queue")}
                        >
                          <span>Current Queue​s</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("queue")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("queue")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("assignqueue")}
                        >
                          <span>Assigned Queue</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("assignqueue")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("assignqueue")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("priority")}
                        >
                          <span>Priority</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("priority")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("priority")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("status")}
                        >
                          <span>Status</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("status")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("status")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                      </>
                    ) : (
                      // --- NORMAL Headings ---
                      <>
                        <th className="workflow-auditor-table-th">
                          <span></span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("episode_identifier")}
                        >
                          <span>Episode Identifier</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("episode_identifier")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("episode_identifier")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("medical_record_number")}
                        >
                          <span>MRN/UR</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("medical_record_number")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("medical_record_number")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("admission_date")}
                        >
                          <span>Admission Date</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("admission_date")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("admission_date")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("separation_date")}
                        >
                          <span>Discharge Date</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("separation_date")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("separation_date")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("length_of_stay")}
                        >
                          <span>LOS</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("length_of_stay")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("length_of_stay")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("speciality")}
                        >
                          <span>Speciality</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("speciality")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("speciality")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("insurer_identifier")}
                        >
                          <span>Health Fund Contract</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("insurer_identifier")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("insurer_identifier")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("drg_codes")}
                        >
                          <span>Pre Audit DRG</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("drg_codes")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("drg_codes")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("weight")}
                        >
                          <span>Pre Audit Revenue</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("weight")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("weight")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        {/* <th className="workflow-auditor-table-th">
                          <span>Audit $</span>
                        </th> */}
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("queue")}
                        >
                          <span>Current Queues​</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("queue")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("queue")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("assignqueue")}
                        >
                          <span>Assigned Queue</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("assignqueue")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("assignqueue")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("priority")}
                        >
                          <span>Priority</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip
                              title={getSortTooltip("priority")}
                              arrow
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("priority")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                        <th
                          className="workflow-auditor-table-th"
                          onClick={() => handleSort("status")}
                        >
                          <span>Status</span>
                          <span className="episodelist-sort-icon">
                            <Tooltip title={getSortTooltip("status")} arrow>
                              <span>
                                <FontAwesomeIcon
                                  icon={renderSortIcon("status")}
                                />
                              </span>
                            </Tooltip>
                          </span>
                        </th>
                         {(codebookcoblhEnv||codebookdevEnv)&&<th className="workflow-coder-table-th">
                    <span>CDQ</span>
                  </th>}
                      </>
                    )}
                  </tr>
                </thead>

                <tbody className="workflow-auditor-table-body">
                  {auditorViewDataLoading ? (
                    <tr>
                      <td colSpan={isCodeEnhanceMode ? "15" : "15"}>
                        <div className="workflow-auditor-table-loader">
                          <LdsRoller />
                        </div>
                      </td>
                    </tr>
                  ) : auditorViewDataError ? (
                    <tr>
                      <td colSpan={isCodeEnhanceMode ? "15" : "15"}>
                        <div className="workflow-auditor-table-error">
                          No data found
                        </div>
                      </td>
                    </tr>
                  ) : dataToDisplay?.length > 0 ? (
                    dataToDisplay?.map((HimTableItem) => {
                      return (
                        <tr
                          key={HimTableItem?.hcp_line_id}
                          className="workflow-auditor-table-tr"
                          onClick={() =>
                            checkAuditorPermissionAndNavigate(HimTableItem)
                          }
                        >
                          {isCodeEnhanceMode ? (
                            // --- CODE ENHANCE BODY CELLS ---
                            <>
                              {/* 1. Empty / Checkbox Placeholder */}
                              {codebookusaEnv && (
                                <td className="workflow-auditor-table-td">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {HimTableItem?.type_patient ? (
                                      <>
                                        <Tooltip
                                          title={HimTableItem.type_patient}
                                        >
                                          <FontAwesomeIcon
                                            icon={getPatientTypeIcon(
                                              HimTableItem.type_patient,
                                            )}
                                            style={{
                                              color: getPatientTypeColor(
                                                HimTableItem.type_patient,
                                              ),
                                              fontSize: "16px",
                                            }}
                                          />
                                        </Tooltip>
                                        <span style={{ marginLeft: "4px" }}>
                                          {/* {HimTableItem.type_patient} */}
                                          {HimTableItem.type_patient
                                            .charAt(0)
                                            .toUpperCase() +
                                            HimTableItem.type_patient.slice(1)}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <FontAwesomeIcon
                                          icon={faUser}
                                          style={{
                                            color: "#757575",
                                            fontSize: "16px",
                                          }}
                                        />
                                        <span style={{ marginLeft: "4px" }}>
                                          -
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </td>
                              )}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem.is_locked
                                    ? functionLocked()
                                    : ""}
                                </div>
                              </td>

                              {/* 2. Episode ID */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  <Link
                                    to="/auditor-enhance-workflow"
                                    onClick={(e) => {
                                      // e.preventDefault(); // stop navigation
                                      sessionStorage.setItem(
                                        "last_hcp_line_id",
                                        HimTableItem?.hcp_line_id,
                                      );
                                      sessionStorage.setItem(
                                        "episodeDetails",
                                        JSON.stringify(HimTableItem),
                                      );

                                      // setIsRowClicked(true);
                                    }}
                                    className="workflow-auditor-table-td-hyperlink"
                                  >
                                    {getHighlightedText(
                                      HimTableItem?.episode_identifier,
                                    )}
                                  </Link>
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.medical_record_number}
                                </div>
                              </td>
                              {/* 3. Admission Date */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.admission_date}
                                </div>
                              </td>

                              {/* 4. Discharge Date */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.separation_date !== null
                                    ? HimTableItem?.separation_date
                                    : "-"}
                                </div>
                              </td>

                              {/* 5. LOS */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.length_of_stay}
                                </div>
                              </td>

                              {/* 6. Specialty */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.speciality
                                    ? HimTableItem?.speciality
                                    : "-"}
                                </div>
                              </td>
                              {/* 7. Health fund contract */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.health_fund_contract
                                    ? HimTableItem?.health_fund_contract
                                    : "-"}
                                </div>
                              </td>
                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.insurer_identifier}
                                </div>
                              </td> */}

                              {/* 7. DRG (Placeholder or First DRG) */}
                              {/* <td className="workflow-auditor-table-td">
                              <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.drgs?.length > 0 ? HimTableItem.drgs[0].drg_code : "-"}
                              </div>
                            </td> */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {(() => {
                                    const drgs = HimTableItem?.drgs || [];
                                    if (!drgs?.length) return "-";

                                    const selectedIndex = getSelectedDrgIndex(
                                      HimTableItem.hcp_line_id,
                                      drgs,
                                    );
                                    const selectedDrg = selectedIndex >= 0 ? drgs[selectedIndex] ?? null : null;

                                    return (
                                      <>
                                        {/* Selected DRG (row-level hover tooltip) */}
                                        <Tooltip
                                          title={
                                            <>
                                              <div>
                                                <b>Version:</b>{" "}
                                                {selectedDrg?.grouper_version ?? "-"}
                                              </div>
                                              <div>
                                                <b>Weight:</b>{" "}
                                                {selectedDrg?.weight ?? "-"}
                                              </div>
                                            </>
                                          }
                                          arrow
                                        >
                                          {/* <span
                                            style={{ cursor: "pointer", fontWeight: 500 }}
                                            onClick={(e) => openDrgMenu(e, HimTableItem.hcp_line_id)}
                                          >
                                            {selectedDrg?.drg_code ?? "-"}
                                          </span> */}
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: 500,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "2px",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();                  
                                              openDrgMenu(e, HimTableItem.hcp_line_id);
                                            }}
                                          >
                                            {selectedDrg?.drg_code ?? "-"}
                                            {drgs?.length > 1 && (
                                              <ArrowDropDownIcon fontSize="small" />
                                            )}
                                          </span>
                                        </Tooltip>

                                        {/* Dropdown */}
                                        <Menu
                                          anchorEl={drgAnchorEl}
                                          open={
                                            Boolean(drgAnchorEl) &&
                                            activeDrgRow ===
                                              HimTableItem.hcp_line_id
                                          }
                                          onClose={closeDrgMenu}
                                          onClick={(e) => e.stopPropagation()} 
                                        >
                                          {drgs.map((drg, index) => (
                                            <Tooltip
                                              key={index}
                                              title={
                                                <>
                                                  <div>
                                                    <b>Version:</b>{" "}
                                                    {drg?.grouper_version ?? "-"}
                                                  </div>
                                                  <div>
                                                    <b>Weight:</b> {drg?.weight ?? "-"}
                                                  </div>
                                                </>
                                              }
                                              placement="right"
                                              arrow
                                            >
                                              <MenuItem
                                                onClick={() => {
                                                  updateSelectedDrgIndex(
                                                    HimTableItem.hcp_line_id,
                                                    index,
                                                  );
                                                  closeDrgMenu();
                                                }}
                                              >
                                                {drg?.drg_code ?? "-"}
                                              </MenuItem>
                                            </Tooltip>
                                          ))}
                                        </Menu>
                                      </>
                                    );
                                  })()}
                                </div>
                              </td>

                              {/* 8. $ (Placeholder or First DRG Cost) */}
                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.drgs?.length > 0
                                    ? HimTableItem.drgs[0].$
                                    : "-"}
                                </div>
                              </td> */}
                              {/* When user selects a drg code among multiple drg codes that corresponding $ value reflect here  */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {(() => {
                                    const drgs = HimTableItem?.drgs || [];
                                    if (!drgs.length) return "-";

                                    const selectedIndex = getSelectedDrgIndex(
                                      HimTableItem.hcp_line_id,
                                      drgs,
                                    );

                                    const selectedDrg =
                                      selectedIndex >= 0 ? drgs[selectedIndex] : null;
                                    const weight = selectedDrg?.weight;

                                    if (
                                      weight == null ||
                                      !Number.isFinite(Number(weight))
                                    ) {
                                      return "-";
                                    }

                                    const revenue = Number(weight) * 7258;

                                    return `$ ${revenue.toLocaleString("en-AU", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`;
                                  })()}
                                </div>
                              </td>

                              {/* 9. Audit Rule Findings */}
                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.audit_findings?.length > 0
                                    ? HimTableItem?.audit_findings[0]
                                        .category_name
                                    : " - "}
                                </div>
                              </td> */}
                              {/* multiple findings will appear in tooltip */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.audit_findings?.length > 0
                                    ? (() => {
                                        const categories =
                                          HimTableItem.audit_findings
                                            .map((f) => f?.category_name)
                                            .filter(Boolean);

                                        const uniqueCategories = [
                                          ...new Set(categories),
                                        ];
                                        const MAX_ITEMS = 2;
                                        const visibleItems =
                                          uniqueCategories.slice(0, MAX_ITEMS);
                                        const hasMore =
                                          uniqueCategories.length > MAX_ITEMS;

                                        return (
                                          <Tooltip
                                            title={
                                              <div
                                                style={{ padding: "4px 8px" }}
                                              >
                                                {uniqueCategories.map(
                                                  (name, idx) => (
                                                    <div key={idx}> {name}</div>
                                                  ),
                                                )}
                                              </div>
                                            }
                                            arrow
                                            placement="top"
                                          >
                                            <div className="audit-findings-cell">
                                              {/* {visibleItems.join(', ')} */}
                                              {visibleItems.map(
                                                (name, index) => (
                                                  <span key={index}>
                                                    {name}
                                                    {index <
                                                      visibleItems.length - 1 &&
                                                      ", "}
                                                  </span>
                                                ),
                                              )}
                                              {hasMore && "..."}
                                            </div>
                                          </Tooltip>
                                        );
                                      })()
                                    : "-"}
                                </div>
                              </td>
                              {/* current queue  */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.current_queues?.length > 0
                                    ? (() => {
                                        const queueNames =
                                          HimTableItem.current_queues
                                            .filter((q) => q?.queue_name)
                                            .map((q) => q.queue_name);

                                        const MAX_ITEMS = 2; // how many to show before "..."
                                        const visibleItems = queueNames.slice(
                                          0,
                                          MAX_ITEMS,
                                        );
                                        const hasMore =
                                          queueNames.length > MAX_ITEMS;

                                        return (
                                          <Tooltip
                                            title={
                                              <div
                                                style={{ padding: "4px 8px" }}
                                              >
                                                {queueNames.map(
                                                  (name, index) => (
                                                    <div key={index}>
                                                      {" "}
                                                      {name}
                                                    </div>
                                                  ),
                                                )}
                                              </div>
                                            }
                                            arrow
                                            placement="top"
                                          >
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "180px",
                                              }}
                                            >
                                              {visibleItems.map(
                                                (name, index) => (
                                                  <span key={index}>
                                                    {/* {visibleItems.length === 1 ? name : name + ","} */}
                                                    {name}
                                                    {index <
                                                      visibleItems.length - 1 &&
                                                      ", "}
                                                  </span>
                                                ),
                                              )}
                                              {hasMore && " ..."}
                                            </div>
                                          </Tooltip>
                                        );
                                      })()
                                    : "-"}
                                </div>
                              </td>

                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {Array.isArray(
                                    HimTableItem?.assigned_queues,
                                  ) && HimTableItem.assigned_queues.length > 0
                                    ? (() => {
                                        const queues =
                                          HimTableItem.assigned_queues
                                            .filter((q) => q?.queue_name)
                                            .map((q) => q.queue_name);

                                        const visibleItem = queues[0];
                                        const hasMore = queues.length > 1;

                                        return (
                                          <Tooltip
                                            title={queues.join(", ")}
                                            arrow
                                            placement="top"
                                          >
                                            <span className="ellipsis-cell">
                                              {visibleItem}
                                              {hasMore &&
                                                ` +${queues.length - 1}`}
                                            </span>
                                          </Tooltip>
                                        );
                                      })()
                                    : "-"}
                                </div>
                              </td>

                              {/* 10. Priority (Numeric Value 1, 2, 3) */}
                              <td className="workflow-auditor-table-td">
                                <div
                                  style={{
                                    padding: "7px 10px",
                                    textAlign: "center",
                                  }}
                                >
                                   {/* {
                                  HimTableItem?.audit_findings?.length > 0
                                    ? HimTableItem?.audit_findings[0]
                                        .priority_value
                                    :
                                     HimTableItem?.priority || "-"} */}
                                 {HimTableItem?.priority ? (
                                    <Badge
                                      className="workflow-auditor-priority"
                                      bg={null}
                                      style={{
                                        backgroundColor:
                                          HimTableItem?.priority === "URGENT"
                                            ? "#FDF2FA"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#FEF6EE"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#F9FAFB"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#FEFCE8"
                                                  : "",
                                        border: `1px solid ${
                                          HimTableItem?.priority === "URGENT"
                                            ? "#FCCEEE"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#F9DBAF"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#EAECF0"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#F9DBAF"
                                                  : ""
                                        }`,
                                        color: `${
                                          HimTableItem?.priority === "URGENT"
                                            ? "#C11574"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#D28800"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#344054"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#344054"
                                                  : ""
                                        }`,
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {HimTableItem?.priority || "-"}
                                    </Badge>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </td>

                              {/* 11. Status (Reused Badge Logic) */}
                              <td className="workflow-auditor-table-td">
                                {Array.isArray(HimTableItem?.status) &&
                                HimTableItem.status.length > 0
                                  ? (() => {
                                      const list = HimTableItem.status.filter(
                                        (s) => s?.status,
                                      );
                                      const topStatus = list?.filter(
                                        (item) => item?.is_primary,
                                      );
                                      const statusText =
                                        topStatus?.map((item) => item.status) ??
                                        "-";
                                      const hasMultiple = list.length > 1;

                                      const getColor = (statusText) => {
                                        const status = statusText[0];
                                        switch (status) {
                                          case "Audit - AI processing complete - codes available for validation":
                                            return "#4CAF50";
                                          case "Audit - Audited":
                                            return "#2E7D32";
                                          case "Audit - Awaiting Audit":
                                          case "Awaiting Audit":
                                            return "#FFA726";
                                          case "Audit - Awaiting CDQ":
                                            return "#FFB300";
                                          case "Audit - CDQ For Review":
                                            return "#FB8C00";
                                          case "Audit - Coding Complete":
                                            return "#00897B";
                                          case "Audit - Locked by user":
                                            return "#757575";
                                          case "Audit - Missing Notes":
                                            return "#E53935";
                                          case "Audit - On Hold":
                                            return "#6A1B9A";
                                          case "Audit - Outstanding":
                                            return "#F44336";
                                          default:
                                            return "#344054";
                                        }
                                      };

                                      return (
                                        <Tooltip
                                          title={
                                            <div style={{ padding: "4px 8px" }}>
                                              {list.map((item, index) => (
                                                <div key={index}>
                                                  {item.status}
                                                </div>
                                              ))}
                                            </div>
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <Box
                                            sx={{
                                              position: "relative",
                                              width: "180px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {/* stacked layers */}
                                            {hasMultiple &&
                                              list
                                                .slice(1, 3)
                                                .map((item, index) => (
                                                  <Box
                                                    key={index}
                                                    sx={{
                                                      position: "absolute",
                                                      top: `${(index + 1) * 4}px`,
                                                      left: `${(index + 1) * 4}px`,
                                                      width: "100%",
                                                      height: "34px",
                                                      borderRadius: "6px",
                                                      backgroundColor:
                                                        "#E0E0E0",
                                                      zIndex: index,
                                                    }}
                                                  />
                                                ))}

                                            {/* top status */}
                                            <Box
                                              sx={{
                                                position: "relative",
                                                zIndex: 1,
                                                backgroundColor: "#FFF",
                                                color: getColor(statusText),
                                                border: "1px solid #D0D5DD",
                                                borderRadius: "6px",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                padding: "6px 8px",
                                                textAlign: "center",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                boxShadow:
                                                  "0 2px 6px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              {statusText}
                                            </Box>

                                            {/* +count badge */}
                                            {list.length > 3 && (
                                              <Box
                                                sx={{
                                                  position: "absolute",
                                                  bottom: "-6px",
                                                  right: "-6px",
                                                  background: "#344054",
                                                  color: "#fff",
                                                  fontSize: "10px",
                                                  borderRadius: "10px",
                                                  px: "5px",
                                                  py: "1px",
                                                }}
                                              >
                                                +{list.length - 1}
                                              </Box>
                                            )}
                                          </Box>
                                        </Tooltip>
                                      );
                                    })()
                                  : "-"}
                              </td>
                              
                            </>
                          ) : (
                            // --- NORMAL BODY CELLS (Existing Layout) ---
                            <>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem.is_locked
                                    ? functionLocked()
                                    : ""}
                                </div>
                              </td>

                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {getHighlightedText(
                                    HimTableItem?.episode_identifier,
                                  )}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.medical_record_number}
                                </div>
                              </td>

                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.admission_date}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.separation_date !== null
                                    ? HimTableItem?.separation_date
                                    : "-"}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.length_of_stay}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.speciality
                                    ? HimTableItem?.speciality
                                    : "-"}
                                </div>
                              </td>
                              {/* 7. Health fund contract */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.health_fund_contract
                                    ? HimTableItem?.health_fund_contract
                                    : "-"}
                                </div>
                              </td>
                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.insurer_identifier}
                                </div>
                              </td> */}

                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {(() => {
                                    const drgs = HimTableItem?.drgs || [];
                                    if (!drgs?.length) return "-";

                                    const selectedIndex = getSelectedDrgIndex(
                                      HimTableItem.hcp_line_id,
                                      drgs,
                                    );
                                    const selectedDrg = selectedIndex >= 0 ? drgs[selectedIndex] ?? null : null;

                                    return (
                                      <>
                                        {/* Selected DRG (row-level hover tooltip) */}
                                        <Tooltip
                                          title={
                                            <>
                                              <div>
                                                <b>Version:</b>{" "}
                                                {selectedDrg?.grouper_version ?? "-"}
                                              </div>
                                              <div>
                                                <b>Weight:</b>{" "}
                                                {selectedDrg?.weight ?? "-"}
                                              </div>
                                            </>
                                          }
                                          arrow
                                        >
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: 500,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "2px",
                                            }}
                                           onClick={(e) => {    
                                            e.stopPropagation();                     
                                                openDrgMenu(e, HimTableItem.hcp_line_id);
                                              }}
                                          >
                                            {selectedDrg?.drg_code ?? "-"}
                                            {drgs?.length > 1 && (
                                              <ArrowDropDownIcon fontSize="small" />
                                            )}
                                          </span>
                                        </Tooltip>

                                        {/* Dropdown */}
                                        <Menu
                                          anchorEl={drgAnchorEl}
                                          open={
                                            Boolean(drgAnchorEl) &&
                                            activeDrgRow ===
                                              HimTableItem.hcp_line_id
                                          }
                                          onClose={closeDrgMenu}
                                          onClick={(e) => e.stopPropagation()} 
                                        >
                                          {drgs.map((drg, index) => (
                                            <Tooltip
                                              key={index}
                                              title={
                                                <>
                                                  <div>
                                                    <b>Version:</b>{" "}
                                                    {drg?.grouper_version ?? "-"}
                                                  </div>
                                                  <div>
                                                    <b>Weight:</b> {drg?.weight ?? "-"}
                                                  </div>
                                                </>
                                              }
                                              placement="right"
                                              arrow
                                            >
                                              <MenuItem
                                                onClick={() => {
                                                  updateSelectedDrgIndex(
                                                    HimTableItem.hcp_line_id,
                                                    index,
                                                  );
                                                  closeDrgMenu();
                                                }}
                                              >
                                                {drg?.drg_code ?? "-"}
                                              </MenuItem>
                                            </Tooltip>
                                          ))}
                                        </Menu>
                                      </>
                                    );
                                  })()}
                                </div>
                              </td>
                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {Number?.isFinite(HimTableItem?.weight)
                                    ? Math.round(
                                        HimTableItem?.weight * 7258,
                                      ).toLocaleString("en-IN")
                                    : 0}
                                </div>
                              </td> */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {(() => {
                                    const drgs = HimTableItem?.drgs || [];
                                    if (!drgs.length) return "-";

                                    const selectedIndex = getSelectedDrgIndex(
                                      HimTableItem.hcp_line_id,
                                      drgs,
                                    );

                                    const selectedDrg =
                                      selectedIndex >= 0 ? drgs[selectedIndex] : null;
                                    const weight = selectedDrg?.weight;

                                    if (
                                      weight == null ||
                                      !Number.isFinite(Number(weight))
                                    ) {
                                      return "-";
                                    }

                                    const revenue = Number(weight) * 7258;

                                    return `$ ${revenue.toLocaleString("en-AU", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`;
                                  })()}
                                </div>
                              </td>

                              {/* <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.audit_weight
                                    ? Math.round(
                                        HimTableItem?.audit_weight * 7258,
                                      ).toLocaleString()
                                    : 0}
                                </div>
                              </td> */}
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.current_queues?.length > 0
                                    ? (() => {
                                        const queueNames =
                                          HimTableItem.current_queues
                                            .filter((q) => q?.queue_name)
                                            .map((q) => q.queue_name);

                                        const MAX_ITEMS = 2; // how many to show before "..."
                                        const visibleItems = queueNames.slice(
                                          0,
                                          MAX_ITEMS,
                                        );
                                        const hasMore =
                                          queueNames.length > MAX_ITEMS;

                                        return (
                                          <Tooltip
                                            title={
                                              <div
                                                style={{ padding: "4px 8px" }}
                                              >
                                                {queueNames.map(
                                                  (name, index) => (
                                                    <div key={index}>
                                                      {" "}
                                                      {name}
                                                    </div>
                                                  ),
                                                )}
                                              </div>
                                            }
                                            arrow
                                            placement="top"
                                          >
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "180px",
                                              }}
                                            >
                                              {visibleItems.map(
                                                (name, index) => (
                                                  <span key={index}>
                                                    {/* {visibleItems.length === 1 ? name : name + ","} */}
                                                    {name}
                                                    {index <
                                                      visibleItems.length - 1 &&
                                                      ", "}
                                                  </span>
                                                ),
                                              )}
                                              {hasMore && " ..."}
                                            </div>
                                          </Tooltip>
                                        );
                                      })()
                                    : "-"}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {Array.isArray(
                                    HimTableItem?.assigned_queues,
                                  ) && HimTableItem.assigned_queues.length > 0
                                    ? (() => {
                                        const queues =
                                          HimTableItem.assigned_queues
                                            .filter((q) => q?.queue_name)
                                            .map((q) => q.queue_name);

                                        const visibleItem = queues[0];
                                        const hasMore = queues.length > 1;

                                        return (
                                          <Tooltip
                                            title={queues.join(", ")}
                                            arrow
                                            placement="top"
                                          >
                                            <span className="ellipsis-cell">
                                              {visibleItem}
                                              {hasMore &&
                                                ` +${queues.length - 1}`}
                                            </span>
                                          </Tooltip>
                                        );
                                      })()
                                    : "-"}
                                </div>
                              </td>
                              <td className="workflow-auditor-table-td">
                                <div style={{ padding: "7px 10px" }}>
                                  {HimTableItem?.priority ? (
                                    <Badge
                                      className="workflow-auditor-priority"
                                      bg={null}
                                      style={{
                                        backgroundColor:
                                          HimTableItem?.priority === "URGENT"
                                            ? "#FDF2FA"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#FEF6EE"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#F9FAFB"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#FEFCE8"
                                                  : "",
                                        border: `1px solid ${
                                          HimTableItem?.priority === "URGENT"
                                            ? "#FCCEEE"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#F9DBAF"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#EAECF0"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#F9DBAF"
                                                  : ""
                                        }`,
                                        color: `${
                                          HimTableItem?.priority === "URGENT"
                                            ? "#C11574"
                                            : HimTableItem?.priority === "HIGH"
                                              ? "#D28800"
                                              : HimTableItem?.priority === "LOW"
                                                ? "#344054"
                                                : HimTableItem?.priority ===
                                                    "OVERDUE"
                                                  ? "#344054"
                                                  : ""
                                        }`,
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {HimTableItem?.priority || "-"}
                                    </Badge>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </td>
                              {/* <td className="workflow-auditor-table-td">
                                <Badge
                                  bg={null}
                                  style={{
                                    backgroundColor: "#FFF",
                                    border: "1px solid #d0d5dd",
                                    color:
                                      HimTableItem?.status ===
                                      "Audit - AI processing complete - codes available for validation"
                                        ? " #4CAF50"
                                        : HimTableItem?.status ===
                                            "Audit - Audited"
                                          ? "#2E7D32"
                                          : HimTableItem?.status ===
                                              "Audit - Awaiting Audit"
                                            ? "#FFA726"
                                            : HimTableItem?.status ===
                                                "Audit - Awaiting CDQ"
                                              ? "#FFB300"
                                              : HimTableItem?.status ===
                                                  "Audit - CDQ For Review"
                                                ? "#FB8C00"
                                                : HimTableItem?.status ===
                                                    "Audit - Coding Complete"
                                                  ? "#00897B"
                                                  : HimTableItem?.status ===
                                                      "Audit - Locked by user"
                                                    ? "#757575"
                                                    : HimTableItem?.status ===
                                                        "Audit - Missing Notes"
                                                      ? "#E53935"
                                                      : HimTableItem?.status ===
                                                          "Audit - On Hold"
                                                        ? "#6A1B9A"
                                                        : HimTableItem?.status ===
                                                            "Audit - Outstanding"
                                                          ? "#F44336"
                                                          : "black",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "30px",
                                    width: "100%",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    whiteSpace: "normal",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    padding: "0 5px",
                                  }}
                                >
                                  <Tooltip title={HimTableItem?.status || "-"}>
                                    <span
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {HimTableItem?.status || "-"}
                                    </span>
                                  </Tooltip>
                                </Badge>
                              </td> */}
                              <td className="workflow-auditor-table-td">
                                {Array.isArray(HimTableItem?.status) &&
                                HimTableItem.status.length > 0
                                  ? (() => {
                                      const list = HimTableItem.status.filter(
                                        (s) => s?.status,
                                      );
                                      const topStatus = list?.filter(
                                        (item) => item?.is_primary,
                                      );
                                      const statusText =
                                        topStatus?.map((item) => item.status) ??
                                        "-";
                                      const hasMultiple = list.length > 1;

                                      const getColor = (statusText) => {
                                        const status = statusText[0];
                                        switch (status) {
                                          case "Audit - AI processing complete - codes available for validation":
                                            return "#4CAF50";
                                          case "Audit - Audited":
                                            return "#2E7D32";
                                          case "Audit - Awaiting Audit":
                                          case "Awaiting Audit":
                                            return "#FFA726";
                                          case "Audit - Awaiting CDQ":
                                            return "#FFB300";
                                          case "Audit - CDQ For Review":
                                            return "#FB8C00";
                                          case "Audit - Coding Complete":
                                            return "#00897B";
                                          case "Audit - Locked by user":
                                            return "#757575";
                                          case "Audit - Missing Notes":
                                            return "#E53935";
                                          case "Audit - On Hold":
                                            return "#6A1B9A";
                                          case "Audit - Outstanding":
                                            return "#F44336";
                                          default:
                                            return "#344054";
                                        }
                                      };

                                      return (
                                        <Tooltip
                                          title={
                                            <div style={{ padding: "4px 8px" }}>
                                              {list.map((item, index) => (
                                                <div key={index}>
                                                  {item.status}
                                                </div>
                                              ))}
                                            </div>
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <Box
                                            sx={{
                                              position: "relative",
                                              width: "180px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {/* stacked layers */}
                                            {hasMultiple &&
                                              list
                                                .slice(1, 3)
                                                .map((item, index) => (
                                                  <Box
                                                    key={index}
                                                    sx={{
                                                      position: "absolute",
                                                      top: `${(index + 1) * 4}px`,
                                                      left: `${(index + 1) * 4}px`,
                                                      width: "100%",
                                                      height: "34px",
                                                      borderRadius: "6px",
                                                      backgroundColor:
                                                        "#E0E0E0",
                                                      zIndex: index,
                                                    }}
                                                  />
                                                ))}

                                            {/* top status */}
                                            <Box
                                              sx={{
                                                position: "relative",
                                                zIndex: 1,
                                                backgroundColor: "#FFF",
                                                color: getColor(statusText),
                                                border: "1px solid #D0D5DD",
                                                borderRadius: "6px",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                padding: "6px 8px",
                                                textAlign: "center",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                boxShadow:
                                                  "0 2px 6px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              {statusText}
                                            </Box>

                                            {/* +count badge */}
                                            {list.length > 3 && (
                                              <Box
                                                sx={{
                                                  position: "absolute",
                                                  bottom: "-6px",
                                                  right: "-6px",
                                                  background: "#344054",
                                                  color: "#fff",
                                                  fontSize: "10px",
                                                  borderRadius: "10px",
                                                  px: "5px",
                                                  py: "1px",
                                                }}
                                              >
                                                +{list.length - 1}
                                              </Box>
                                            )}
                                          </Box>
                                        </Tooltip>
                                      );
                                    })()
                                  : "-"}
                              </td>

                              {(codebookcoblhEnv || codebookdevEnv) && (
                                <td className="workflow-him-table-td">
                        {HimTableItem?.cdq_count > 0 ? (
                          <span
                            className="workflow-him-cdq-view"
                            style={{
                              color: "#175CD3",
                              fontWeight: 500,
                              fontSize: "13px",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              whiteSpace: "nowrap",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewCdqResponses(HimTableItem);
                            }}
                          >
                            View ({HimTableItem.cdq_count})
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>)}
                            </>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={isCodeEnhanceMode ? "15" : "15"}>
                        <div className="workflow-auditor-table-no-records">
                          No records found
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="auditorTable-footer">
              <div>
                <Pagination className="auditor-pagination">
                  <Pagination.First
                    className="auditor-pagination-li"
                    onClick={() => handlePageChange(1)}
                    disabled={filtersPayload?.page_number <= 1}
                  />
                  <Pagination.Prev
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number - 1)
                    }
                    disabled={filtersPayload?.page_number <= 1}
                    className="auditor-prev-btn"
                  />
                  <Pagination.Item className="auditor-pagination-li">
                    Page {filtersPayload?.page_number} of {totalPages}
                  </Pagination.Item>
                  <Pagination.Next
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number + 1)
                    }
                    disabled={filtersPayload?.page_number >= totalPages}
                    className="auditor-next-btn"
                  />
                  <Pagination.Last
                    className="auditor-pagination-li"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={filtersPayload?.page_number === totalPages}
                  />
                </Pagination>
              </div>
              {/* <div className="HimTable-row-options">
                <Form.Select
                  className="HimTable-select"
                  value={filtersPayload?.page_size}
                  onChange={handleRowsPerPageChange}
                >
                  <option
                    value=""
                    disabled
                    className="HimTable-rows-per-page_number"
                  >
                    Rows per page
                  </option>

                  <option value={10} className="HimTable-rows-per-page">
                    10
                  </option>
                  <option value={20} className="HimTable-rows-per-page">
                    20
                  </option>
                  <option value={50} className="HimTable-rows-per-page">
                    50
                  </option>
                </Form.Select>
              </div> */}
            </div>
          </div>
        </div>
        {preferencesLoading ? (
          <div
            className="modal fade coding-screen-popup user-preference-modal show"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div
                className="modal-content shadow"
                style={{
                  width: "fit-content",
                  minWidth: "420px",
                  maxWidth: "500px",
                  borderRadius: "12px",
                  border: "none",
                  overflow: "hidden",
                }}
              >
                <div
                  className="modal-body d-flex flex-column justify-content-center align-items-center py-5"
                  style={{ minHeight: "220px" }}
                >
                  <div
                    className="mb-4"
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      background: "#f5f7fa",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Spinner animation="border" variant="primary" />
                  </div>

                  <h5
                    className="mb-2"
                    style={{
                      color: "#032f49",
                      fontWeight: 600,
                    }}
                  >
                    Loading Preferences
                  </h5>

                  <p
                    className="mb-0 text-center"
                    style={{
                      color: "#6c757d",
                      maxWidth: "320px",
                      fontSize: "14px",
                    }}
                  >
                    Please wait while we fetch your preferences. This will only
                    take a moment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          showUserPreferenceModal && (
            <div
              className="modal fade coding-screen-popup user-preference-modal show"
              style={{ display: "block" }}
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
                style={{
                  width: "550px",
                  maxWidth: "90vw",
                  margin: "1.75rem auto",
                }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => {
                        setShowUserPreferenceModal(false);
                        setQueueSelected(loginUserID);
                        setSelectedQueueIndex(null);
                        setIsOptionSelected(false);
                        setSelectedSection("");
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    Kindly select your desired coding module
                  </div>
                  <div className="modal-footer mb-3">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled={
                        showAvailableAuditQueuesLoading ||
                        !preferences?.["Code Assist"]
                      }
                      onClick={() => navigateToDesiredPage("assist")}
                    >
                      Code Assist
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled={
                        showAvailableAuditQueuesLoading ||
                        !preferences?.["Code Accelerate"]
                      }
                      onClick={() => navigateToDesiredPage("accelerate")}
                    >
                      Code Accelerate
                    </button>
                  </div>
                  {showAvailableAuditQueuesError?.status === 404 && (
                    <span style={{ textAlign: "center", color: "red" }}>
                      This episode is not assigned to any queue or user.
                    </span>
                  )}

                  {(() => {
                    // ================== CATEGORIZE QUEUES ==================
                    const assignedAuditorQueues = clickedEpisodeQueues?.filter(
                      (q) =>
                        q?.assigned_user_id &&
                        q?.assigned_username &&
                        q?.queue_id !== null &&
                        q?.queue_id !== undefined &&
                        q?.queue_name?.trim() &&
                        (q?.assignment_reason === null ||
                          q?.assignment_reason === undefined ||
                          q?.assignment_reason === "") &&
                        filtersPayload.queue?.length === 0,
                    ) || [];

                    const cdqReviewQueues = clickedEpisodeQueues.filter(
                      (q) =>
                        q?.assigned_user_id &&
                        q?.assigned_username &&
                        (q?.queue_id === null || q?.queue_id === undefined) &&
                        (!q?.queue_name || !q.queue_name.trim()) && (q?.assignment_reason === null ||
                          q?.assignment_reason === undefined ||
                          q?.assignment_reason === ""),
                    ) || [];

                    const forReviewQueues = clickedEpisodeQueues?.filter(
                      (q) =>
                        q?.assigned_user_id &&
                        q?.assigned_username &&
                        q?.line_assignment_id &&
                        q?.assignment_reason &&
                        q.assignment_reason.trim() !== "",
                    ) || [];

                    const availableQueues = clickedEpisodeQueues?.filter(
                      (q) => !("assigned_user_id" in q),
                    ) || [];

                    const { activeSection, hasFilterQueue } = getHighlightState({
                      assignedAuditorQueues,
                      cdqReviewQueues,
                      forReviewQueues,
                      availableQueues,
                    });

                    // Single source of truth for highlighting any button
                    const isHighlighted = (sectionName, item, matchFn) => {
                      // User explicitly picked an item → only that item highlights
                      if (isOptionSelected) {
                        return (
                          selectedSection === sectionName &&
                          matchFn(selectedQueueIndex)
                        );
                      }

                      // No explicit selection → use priority section
                      if (activeSection !== sectionName) return false;

                      // Single item in that section → highlight it
                      const counts = {
                        assignedAuditor: assignedAuditorQueues.length,
                        CDQReview: cdqReviewQueues.length,
                        forReview: forReviewQueues.length,
                        auditorQueues: availableQueues.length,
                      };
                      if (counts[sectionName] === 1) return true;

                      // Multiple items:
                      // For Available Queues with filter → match by filter queue_id
                      if (sectionName === "auditorQueues" && hasFilterQueue) {
                        return filtersPayload.queue.includes(item?.queue_id);
                      }

                      // Otherwise match against auto-selected default
                      if (selectedQueueIndex) {
                        return matchFn(selectedQueueIndex);
                      }

                      return false;
                    };

                    const btnStyle = (highlight) => ({
                      flex: "1 1 calc(50% - 12px)",
                      minWidth: "120px",
                      padding: "6px 8px",
                      borderRadius: "6px",
                      border: `2px solid ${highlight ? "#032f49" : "#dee2e6"}`,
                      backgroundColor: highlight ? "#032f49" : "transparent",
                      color: highlight ? "white" : "#212529",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      textAlign: "center",
                      transition: "all 0.2s ease",
                      boxSizing: "border-box",
                    });

                    if (showAvailableAuditQueuesLoading) {
                      return (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            Loading queues...
                          </div>
                        );
                      }
  
                      return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "12px",
                              padding: "12px 16px",
                            }}
                          >
                            {/* ================= ASSIGNED AUDITORS ================= */}
                            {assignedAuditorQueues.length > 0 && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Assigned Auditors:
                                </strong>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                    overflow: "auto",
                                    maxHeight: "45vh",
                                  }}
                                >
                                  {assignedAuditorQueues.map((queue) => {
                                    const highlight = isHighlighted(
                                      "assignedAuditor", queue,
                         (q) => q?.queue_id === queue?.queue_id &&
                                    q?.assigned_user_id ===
                                      queue?.assigned_user_id);
                                    return (
                                      <Tooltip
                                        key={queue.queue_id}
                                        title={
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              padding: "4px 6px",
                                            }}
                                          >
                                            <div>
                                              <b>Reason:</b> {queue.assignment_reason || "N/A"}
                                            </div>
                                          </div>
                                        }
                                        arrow
                                        placement="top"
                                      >
                                        <button
                                          type="button"
                                          style={btnStyle(highlight)}
                                          onClick={() =>
                                            handleQueueSelect(queue, "assignedAuditor")
                                          }
                                        >
                                          {queue.queue_name} : {queue.assigned_username}
                                        </button>
                                      </Tooltip>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* ================= CDQ REVIEW REQUIRED ================= */}
                            {cdqReviewQueues.length > 0 && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  CDQ Review Required
                                </strong>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                    overflow: "auto",
                                    maxHeight: "45vh",
                                  }}
                                >
                                  {cdqReviewQueues.map((queue) => {
                                    const highlight = isHighlighted(
                                     "CDQReview",
                                     queue,
                                     (q) =>
                                     q?.assigned_user_id ===
                                    queue?.assigned_user_id,
                                  );
                                    return (
                                      <Tooltip
                                        key={queue.assigned_user_id}
                                        title={
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              padding: "4px 6px",
                                            }}
                                          >
                                            <div>
                                              <b>User:</b> {queue.assigned_username || "N/A"}
                                            </div>
                                          </div>
                                        }
                                        arrow
                                        placement="top"
                                      >
                                        <button
                                          type="button"
                                          style={btnStyle(highlight)}
                                          onClick={() =>
                                            handleQueueSelect(queue, "CDQReview")
                                          }
                                        >
                                          {queue.assigned_username}
                                        </button>
                                      </Tooltip>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* ================= FOR REVIEW ================= */}
                            {forReviewQueues.length > 0 && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  For Review:
                                </strong>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    overflow: "auto",
                                    maxHeight: "300px",
                                  }}
                                >
                                  {forReviewQueues.map((queue) => {
                                    const highlight = isHighlighted(
                                  "forReview",
                                  queue,
                                  (q) => q?.queue_id === queue?.queue_id,
                                );
                                    return (
                                      <Tooltip
                                        key={queue.queue_id}
                                        title={
                                          <div>
                                            <div>
                                              <b>User:</b> {queue.assigned_username || "-"}
                                            </div>
                                            <div>
                                              <b>Reason:</b> {queue.assignment_reason}
                                            </div>
                                          </div>
                                        }
                                      >
                                        <button
                                          type="button"
                                          style={btnStyle(highlight)}
                                          onClick={() =>
                                            handleQueueSelect(queue, "forReview")
                                          }
                                        >
                                          {queue.assigned_username}:{" "}
                                         {queue.assignment_reason}
                                        </button>
                                      </Tooltip>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* ================= AVAILABLE AUDITOR QUEUES ================= */}
                            {availableQueues.length > 0 && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Available Auditor Queues:
                                </strong>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                  }}
                                >
                                  {availableQueues.map((queue) => {
                                    const highlight = isHighlighted(
                                  "auditorQueues",
                                  queue,
                                  (q) => q?.queue_id === queue?.queue_id,
                                );
                                    return (
                                      <button
                                        key={queue.queue_id}
                                        type="button"
                                        style={btnStyle(highlight)}
                                        onClick={() =>
                                          handleQueueSelect(
                                            queue,
                                            "auditorQueues",
                                          )
                                        }
                                      >
                                        {queue.queue_name}
                                      </button>
                                    );
                                  })}
                                </div>
                              </>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          )
        )}

        <AuditorFilterModal
          show={showAuditorFilter}
          onClose={handleModalClose}
          setShowAuditorFilter={setShowAuditorFilter}
          setCoderSearchTerm={setCoderSearchTerm}
        />
      </div>
       <CdqResponseHistoryModal
              show={showCdqModal}
              onClose={handleCloseCdqModal}
              loading={loadingCdqHistoryData}
              error={errorCdqHistoryData}
              episodeIdentifier={selectedCdqRecord?.episode_identifier}
               totalCount={cdqHistoryData?.count_cdq_response}
                currentPage={cdqPageNumber}
                onPageChange={handleCdqPageChange}
              // onLoadMore={handleLoadMoreCdqResponses}
               responses={cdqHistoryData?.cdq_responses || []}
            />
    </>
  );
};

export default AuditorView;
